import { render, staticRenderFns } from "./TImage.vue?vue&type=template&id=34891555&"
import script from "./TImage.vue?vue&type=script&lang=ts&"
export * from "./TImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports